import { DocumentPackageType } from './document-package';
export var ProcessorName;
(function (ProcessorName) {
    ProcessorName["AMBIGUITY_PROCESSOR"] = "ambiguity-processor";
    ProcessorName["BID_COMPARISONS"] = "bid-comparisons";
    ProcessorName["BID_GAPS"] = "bid-gaps";
    ProcessorName["BREEAM_ENERGY_CHECK"] = "breeam-energy-check";
    ProcessorName["BREEZE"] = "breeze";
    ProcessorName["BUILDING_OPTIMIZER"] = "building-optimizer";
    ProcessorName["BYG_DEADLINES"] = "byg-deadlines";
    ProcessorName["BYG_MANDATORY_HEADER"] = "byg-mandatory-header";
    ProcessorName["BYG_NAMES"] = "byg-names";
    ProcessorName["BYG_TIME_PERIOD_DEADLINES"] = "byg-time-period-deadlines";
    ProcessorName["CEILING_GRID_OPTIMIZER"] = "ceiling-grid-optimizer";
    ProcessorName["CHECK_LIST"] = "check-list";
    ProcessorName["CONTRACT_DEVIATION_CHECKER"] = "contract-deviation-checker";
    ProcessorName["CONTRACT_EXTERNAL_DEVIATION"] = "contract-external-deviation";
    ProcessorName["CONTRACT_INTERNAL_DEVIATION"] = "contract-internal-deviation";
    ProcessorName["CONTRACT_RISK_PROCESSOR"] = "contract-risk-processor";
    ProcessorName["CONTRADICTION_PROCESSOR"] = "contradiction-processor";
    ProcessorName["DEADLINE_EXTRACTOR"] = "deadline-extractor";
    ProcessorName["DELIVERABLE_PROCESSOR"] = "deliverable-processor";
    ProcessorName["DOCUMENT_LABEL_ASSIGN"] = "document-label-assign";
    ProcessorName["DOCUMENT_TO_PDF_CONVERTER"] = "document-to-pdf-converter";
    ProcessorName["DRAWING_CLASSIFIER"] = "drawing-classifier";
    ProcessorName["DUPLICATE_CHECKER"] = "duplicate-checker";
    ProcessorName["EDITABLE_DOCUMENT"] = "editable-document";
    ProcessorName["EXCEL_CONTENT_EXTRACTOR"] = "excel-content-extractor";
    ProcessorName["FDV_CLASSIFIER"] = "fdv-classifier";
    ProcessorName["FDV_MANDATORY"] = "fdv-mandatory";
    ProcessorName["FDV_MISSING_DRAWINGS"] = "fdv-missing-drawings";
    ProcessorName["FILENAME_CHECK"] = "filename-check";
    ProcessorName["FILENAME_SUGGESTION"] = "filename-suggestion";
    ProcessorName["FUNCTIONAL_DESCRIPTIONS"] = "functional-descriptions";
    ProcessorName["GPT_DOCUMENT_CLASSIFIER"] = "gpt-document-classifier";
    ProcessorName["HUMAN_INTELLIGENCE"] = "human-intelligence";
    ProcessorName["IFC_EXPORT"] = "ifc-export";
    ProcessorName["IFC_EXTRACTION"] = "ifc-extraction";
    ProcessorName["KVALIFIKASJONSKRAV_CHECKER"] = "kvalifikasjonskrav-checker";
    ProcessorName["LEGAL_CONTRACT_RISK"] = "legal-contract-risk";
    ProcessorName["LOAD_CALCULATION_PROCESSOR"] = "load-calculation-processor";
    ProcessorName["LUM_SCHEDULE_GENERATOR"] = "lum-schedule-generator";
    ProcessorName["MISSING_REQUIREMENTS"] = "missing-requirements";
    ProcessorName["MISSING_STANDARDS"] = "missing-standards";
    ProcessorName["ORG_INFO"] = "org-info";
    ProcessorName["PARSER_CONTENT_EXTRACTOR"] = "parser-content-extractor";
    ProcessorName["PARSER_IMAGE_CONVERTER"] = "parser-image-converter";
    ProcessorName["PARSER_OPENAI_EMBEDDINGS"] = "parser-openai-embeddings";
    ProcessorName["PIDS_ANALYSER"] = "pids-analyser";
    ProcessorName["PRE_PARSER_OCR"] = "pre-parser-ocr";
    ProcessorName["PRODUCTS_COMPARE"] = "products-compare";
    ProcessorName["PROJECT_SCOPE_RISK"] = "project-scope-risk";
    ProcessorName["REFERENCE_FINDER"] = "reference-finder";
    ProcessorName["REPORT_GEN_PRECHECK"] = "report-gen-precheck";
    ProcessorName["REPORT_GEN_PROCESSOR"] = "report-gen-processor";
    ProcessorName["REPORT_TEMPLATE_GENERATOR"] = "report-template-generator";
    ProcessorName["RESERVATION_RISK"] = "reservation-risk";
    ProcessorName["RESPONSIBILITY_RISK"] = "responsibility-risk";
    ProcessorName["REVIT_GENERATOR"] = "revit-generator";
    ProcessorName["RISK_PROCESSOR"] = "risk-processor";
    ProcessorName["SCHEDULE_CHECK"] = "schedule-check";
    ProcessorName["SFP"] = "sfp";
    ProcessorName["SIMILAR_HEADERS"] = "similar-headers";
    ProcessorName["SITE_DUE_DILIGENCE"] = "site-due-diligence";
    ProcessorName["SITE_RISK_PROCESSOR"] = "site-risk-processor";
    ProcessorName["SPACE_ANALYSIS"] = "space-analysis";
    ProcessorName["ST_ANBEFALE"] = "st-anbefale";
    ProcessorName["ST_COMPARE"] = "st-compare";
    ProcessorName["ST_VALID_CHECKER"] = "st-valid-checker";
    ProcessorName["SUMMARY_PROCESSOR"] = "summary-processor";
    ProcessorName["TENDER_RFP_EXTRACTION"] = "tender-rfp-extraction";
    ProcessorName["TEXT_PROCESSOR_ANBEFALE"] = "text-processor-anbefale";
    ProcessorName["TEXT_PROCESSOR_GLIST"] = "text-processor-glist";
    ProcessorName["TEXT_PROCESSOR_GLIST_DD"] = "text-processor-glist-dd";
    ProcessorName["TEXT_PROCESSOR_GLIST_FDV"] = "text-processor-glist-fdv";
    ProcessorName["TEXT_PROCESSOR_GLIST_FDV_UK"] = "text-processor-glist-fdv-uk";
    ProcessorName["TEXT_PROCESSOR_GLIST_INF"] = "text-processor-glist-inf";
    ProcessorName["TEXT_PROCESSOR_GLIST_LB_KG"] = "text-processor-glist-lb-kg";
    ProcessorName["TEXT_PROCESSOR_GLIST_UK"] = "text-processor-glist-uk";
    ProcessorName["TEXT_PROCESSOR_HIMLING"] = "text-processor-himling";
    ProcessorName["TEXT_PROCESSOR_LYDKRAV"] = "text-processor-lydkrav";
    ProcessorName["TEXT_PROCESSOR_PRICES"] = "text-processor-prices";
    ProcessorName["TEXT_PROCESSOR_SAMSPILL"] = "text-processor-samspill";
    ProcessorName["TEXT_PROCESSOR_SENTRALISERT"] = "text-processor-sentralisert";
    ProcessorName["TEXT_PROCESSOR_SUBJECTS"] = "text-processor-subjects";
    ProcessorName["TEXT_PROCESSOR_TEK17"] = "text-processor-tek17";
    ProcessorName["TEXT_PROCESSOR_VAGUE"] = "text-processor-vague";
    ProcessorName["UNIT_CHECKER"] = "unit-checker";
    ProcessorName["UNIT_OF_MEASURE_CHECKER"] = "unit-of-measure-checker";
    ProcessorName["U_VALUE_CHECKER"] = "u-value-checker";
    ProcessorName["UVALUE"] = "uvalue";
    ProcessorName["VAGUE_WORDING_RISK"] = "vague-wording-risk";
    ProcessorName["VENTILATION_SFP_CHECKER"] = "ventilation-sfp-checker";
    ProcessorName["VERSION_COMPARE"] = "version-compare";
    // Retained for parsing historical findings created by the retired processor.
    ProcessorName["SPEC_REQUIREMENTS_PROCESSOR"] = "spec-requirements-processor";
})(ProcessorName || (ProcessorName = {}));
// This is the list of processors that are available for each document package type.
// Used to for example show available processors in the start pipeline menu in the backoffice when text processing is selected.
export const PROCESSORS_BY_PACKAGE_TYPE = {
    [DocumentPackageType.TENDER_DOCUMENTS]: [
        ProcessorName.DEADLINE_EXTRACTOR,
        ProcessorName.CONTRACT_EXTERNAL_DEVIATION,
        ProcessorName.CONTRACT_INTERNAL_DEVIATION,
        ProcessorName.REFERENCE_FINDER,
        ProcessorName.KVALIFIKASJONSKRAV_CHECKER,
        ProcessorName.MISSING_REQUIREMENTS,
        ProcessorName.MISSING_STANDARDS,
        ProcessorName.RISK_PROCESSOR,
        ProcessorName.ST_ANBEFALE,
        ProcessorName.ST_VALID_CHECKER,
        ProcessorName.TEXT_PROCESSOR_ANBEFALE,
        ProcessorName.TEXT_PROCESSOR_GLIST,
        ProcessorName.TEXT_PROCESSOR_SUBJECTS,
        ProcessorName.CHECK_LIST,
        ProcessorName.CONTRADICTION_PROCESSOR,
    ],
    [DocumentPackageType.OFFER]: [
        ProcessorName.BID_COMPARISONS,
        ProcessorName.DEADLINE_EXTRACTOR,
        ProcessorName.CONTRACT_EXTERNAL_DEVIATION,
        ProcessorName.CONTRACT_INTERNAL_DEVIATION,
        ProcessorName.REFERENCE_FINDER,
        ProcessorName.PRODUCTS_COMPARE,
        ProcessorName.RISK_PROCESSOR,
        ProcessorName.ST_COMPARE,
        ProcessorName.ST_VALID_CHECKER,
        ProcessorName.TEXT_PROCESSOR_GLIST,
        ProcessorName.TEXT_PROCESSOR_PRICES,
        ProcessorName.TEXT_PROCESSOR_SUBJECTS,
        ProcessorName.TEXT_PROCESSOR_TEK17,
        ProcessorName.CONTRADICTION_PROCESSOR,
    ],
    [DocumentPackageType.TENANT_SPECIFICATION]: [
        ProcessorName.DEADLINE_EXTRACTOR,
        ProcessorName.REFERENCE_FINDER,
        ProcessorName.PRODUCTS_COMPARE,
        ProcessorName.RISK_PROCESSOR,
        ProcessorName.ST_COMPARE,
        ProcessorName.TEXT_PROCESSOR_GLIST,
        ProcessorName.TEXT_PROCESSOR_HIMLING,
        ProcessorName.TEXT_PROCESSOR_SENTRALISERT,
        ProcessorName.TEXT_PROCESSOR_SUBJECTS,
        ProcessorName.TEXT_PROCESSOR_TEK17,
    ],
    [DocumentPackageType.TENANT_REQUIREMENTS]: [
        ProcessorName.DEADLINE_EXTRACTOR,
        ProcessorName.CONTRACT_DEVIATION_CHECKER,
        ProcessorName.CONTRACT_EXTERNAL_DEVIATION,
        ProcessorName.CONTRACT_INTERNAL_DEVIATION,
        ProcessorName.REFERENCE_FINDER,
        ProcessorName.PRODUCTS_COMPARE,
        ProcessorName.RISK_PROCESSOR,
        ProcessorName.ST_COMPARE,
        ProcessorName.ST_VALID_CHECKER,
        ProcessorName.TEXT_PROCESSOR_GLIST,
        ProcessorName.TEXT_PROCESSOR_HIMLING,
        ProcessorName.TEXT_PROCESSOR_SENTRALISERT,
        ProcessorName.TEXT_PROCESSOR_SUBJECTS,
        ProcessorName.TEXT_PROCESSOR_TEK17,
        ProcessorName.CONTRADICTION_PROCESSOR,
    ],
    [DocumentPackageType.CONTRACT_REVIEW]: [
        ProcessorName.DEADLINE_EXTRACTOR,
        ProcessorName.CONTRACT_EXTERNAL_DEVIATION,
        ProcessorName.CONTRACT_INTERNAL_DEVIATION,
        ProcessorName.REFERENCE_FINDER,
        ProcessorName.KVALIFIKASJONSKRAV_CHECKER,
        ProcessorName.MISSING_REQUIREMENTS,
        ProcessorName.RISK_PROCESSOR,
        ProcessorName.ST_VALID_CHECKER,
        ProcessorName.TEXT_PROCESSOR_ANBEFALE,
        ProcessorName.TEXT_PROCESSOR_SUBJECTS,
        ProcessorName.CHECK_LIST,
        ProcessorName.LEGAL_CONTRACT_RISK,
        ProcessorName.CONTRADICTION_PROCESSOR,
    ],
    [DocumentPackageType.MANAGEMENT_OPERATIONS_MAINTENANCE]: [
        ProcessorName.EDITABLE_DOCUMENT,
        ProcessorName.FDV_MANDATORY,
        ProcessorName.FDV_MISSING_DRAWINGS,
        ProcessorName.FILENAME_CHECK,
        ProcessorName.FUNCTIONAL_DESCRIPTIONS,
        ProcessorName.MISSING_REQUIREMENTS,
        ProcessorName.TEXT_PROCESSOR_GLIST_FDV,
        ProcessorName.TEXT_PROCESSOR_GLIST_FDV_UK,
        ProcessorName.CHECK_LIST,
    ],
    [DocumentPackageType.DUE_DILIGENCE]: [
        ProcessorName.ORG_INFO,
        ProcessorName.TEXT_PROCESSOR_GLIST_DD,
    ],
    [DocumentPackageType.RFP_RFQ_REVIEW]: [ProcessorName.DEADLINE_EXTRACTOR],
    [DocumentPackageType.DESIGN_PACKAGE_REVIEW]: [
        ProcessorName.AMBIGUITY_PROCESSOR,
        ProcessorName.CONTRADICTION_PROCESSOR,
        ProcessorName.FDV_MISSING_DRAWINGS,
        ProcessorName.REFERENCE_FINDER,
        ProcessorName.ST_VALID_CHECKER,
    ],
};
